import { Datepicker } from 'vanillajs-datepicker';

import config from '../../../config/config-default';

const loadJson = async (fileName) => {
	const response = await fetch(
		`https://bookings.skipbinbrisbane.com.au/json/${fileName}.json`,
		{
			headers: {
				'Content-Type': 'application/json',
			},
		},
	);

	return response.json();
};

const showExtraDaysInfo = (extraDays) => {
	const formCharge = document.getElementById('charge');
	const formExtraDays = document.getElementById('extra-days');
	const extraDaysInfo = document.getElementById('extra-days-info');
	const extraDaysRate = document.getElementById('extra-days-rate');
	const infoCharge = document.getElementById('info-charge-2');
	const infoExtraDays = document.getElementById('info-extra-days-2');
	const infoSubtotal = document.getElementById('info-subtotal-2');

	const extraDayRate =
		window[config.globalScope].options.costs.per_day_over || 0;
	extraDaysRate.textContent = extraDayRate.toFixed(2);

	const charge = +formCharge.value;
	const extraDayCost = extraDays > 0 ? extraDays * extraDayRate : 0;
	formExtraDays.value = extraDayCost;
	const subtotal = charge + extraDayCost;

	infoCharge.textContent = charge.toFixed(2);
	infoExtraDays.textContent = extraDayCost.toFixed(2);
	infoSubtotal.textContent = subtotal.toFixed(2);

	extraDaysInfo.style.display = extraDays > 0 ? 'block' : 'none';
};

const initStep2 = async () => {
	const deliveryDate = document.getElementById('delivery-date');
	const deliveryDateIcon = document.getElementById('delivery-date-icon');
	const pickupDate = document.getElementById('pickup-date');
	const pickupDateIcon = document.getElementById('pickup-date-icon');
	const suburbPostcode = document.getElementById('suburb');

	const [days, suburbs] = await Promise.all([
		loadJson('days'),
		loadJson('suburbs'),
	]);
	window[config.globalScope].options.days = days;
	window[config.globalScope].options.suburbs = suburbs;

	const date = new Date();
	date.setDate(date.getDate() + 1);
	const options = {
		buttonClass: 'btn',
		format: 'dd/mm/yyyy',
		minDate: date,
		orientation: 'bottom',
		datesDisabled: [],
		daysOfWeekDisabled: days.exclude_days || [],
	};
	for (let i = 0; i < (days.exclude_dates || []).length; i += 1) {
		options.datesDisabled[i] = new Date(
			`${days.exclude_dates[i]} 00:00:00`,
		);
	}
	const deliveryDatepicker = new Datepicker(deliveryDate, options);
	const pickupDatepicker = new Datepicker(pickupDate, options);

	const processDates = () => {
		const delDate = deliveryDatepicker.getDate();
		const pickDate = pickupDatepicker.getDate();
		if (delDate) {
			pickupDatepicker.setOptions({ minDate: delDate });
		}
		if (delDate && pickDate) {
			if (pickDate < delDate) {
				pickupDatepicker.setDate(delDate);
				return;
			}
			const oneDay = 1000 * 60 * 60 * 24;
			const diffInTime = pickDate.getTime() - delDate.getTime();
			const diffInDays = Math.ceil(diffInTime / oneDay);
			const maxDays = 7;
			showExtraDaysInfo(diffInDays - maxDays);
		}
	};

	deliveryDate.addEventListener('changeDate', processDates);
	pickupDate.addEventListener('changeDate', processDates);

	deliveryDateIcon.addEventListener('click', () => deliveryDatepicker.show());
	pickupDateIcon.addEventListener('click', () => pickupDatepicker.show());

	let html = '';
	for (let i = 0; i < suburbs.length; i += 1) {
		const [postcode, suburb] = suburbs[i];
		html += `<option value="${suburb} ${postcode}">${suburb} ${postcode}</option>`;
	}
	suburbPostcode.insertAdjacentHTML('beforeend', html);
};

export default initStep2;
